import {ApiBaseUrl, AppName, EnvironmentMetadata, EnvironmentName} from '@emma-labs/shared/typescript';

export const environment: EnvironmentMetadata = {
  enableProdMode: true,
  environment: EnvironmentName.STAGING,
  app: AppName.EMMA_PRO,
  msProposalApiBase: `${ApiBaseUrl.STAGING}/ms-proposal`,
  msSaleApiBase: `${ApiBaseUrl.STAGING}/ms-sale`,
  msFnaApiBase: `${ApiBaseUrl.STAGING}/ms-fna`,
  apiBase: `${ApiBaseUrl.STAGING}`,
  showDevControls: true,
  launchDarklyClientId: '65820edf6aa9950fdece3487',
  datadogLogsClientToken: 'pub1f0775c834675e86644b68112305b88d',
  version: 'staging@c7ac2c15818bcc8f088eb33dc1392df62fb7fb93',
};
